import ipRegex from 'ip-regex'

/**
 * Returns client ip address or null
 *
 * @returns {(string | null)} ip address or null, in case of errors
 */
export const getIpAddress = async (): Promise<string | null> => {
  let ip_address = null
  const res = await fetch('https://www.cloudflare.com/cdn-cgi/trace', { method: 'GET' })
  const data = await res.text()
  const address = data.match(ipRegex())

  if (address) {
    ip_address = address[0]
  }
  return ip_address
}
